import type { TenantTerminologyConfig } from './types';
import { TenantTerminologyService } from './TenantTerminologyService';

const tenantModules = import.meta.glob('./tenants/*.json', { eager: true }) as Record<
  string,
  { default: TenantTerminologyConfig }
>;

function readTenantConfig(
  module: { default?: TenantTerminologyConfig } | TenantTerminologyConfig,
): TenantTerminologyConfig {
  if ('default' in module && module.default) return module.default;
  return module as TenantTerminologyConfig;
}

export function loadTenantConfigurations(service: TenantTerminologyService): void {
  for (const module of Object.values(tenantModules)) {
    service.register(readTenantConfig(module));
  }
}

export function listTenantIds(): string[] {
  return Object.values(tenantModules).map((m) => readTenantConfig(m).tenantId);
}
